<template>
<div>
  <form class="ui form" @submit.prevent="search()">
    <h4 class="ui dividing header">検索条件</h4>
    <div class="fields">
      <div class="field">
        <label>ステータス</label>
        <dropdown v-model="searchForm.model.status" :placeholder="'すべて'" @change="search()">
          <option value="">すべて</option>
          <option value="pending">承認待ち</option>
          <option value="approved">承認済み</option>
          <option value="rejected">却下</option>
        </dropdown>
      </div>
      <div class="six wide field">
        <label>タイトル / コメント / 店舗名 / ユーザー名</label>
        <div class="ui action input">
          <input v-model="searchForm.model.q" type="text" placeholder="検索条件">
          <button class="ui teal button">Search</button>
        </div>
      </div>
    </div>
  </form>

  <div class="search-result" :class="{'loading': searchForm.waiting}">
    <div class="ui vertical centered loader" :class="{'active': searchForm.waiting}"></div>
    <div class="ui horizontal divider header">検索結果</div>
    <div class="relative">
      <pagination :pager="pager" :callback="search"></pagination>
    </div>
    <table class="ui compact table">
      <thead>
        <tr>
          <th>口コミID</th>
          <th>投稿日時</th>
          <th>ステータス</th>
          <th>投稿者名</th>
          <th>店舗名</th>
          <th>評価</th>
          <th>詳細確認</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="review in reviews" :key="review.id">
          <td>{{ review.id }}</td>
          <td>{{ review.created_at | formatDatetime }}</td>
          <td>{{ review.status_label }}</td>
          <td>{{ review.member.name || review.member.name_kana || '（未設定）' }}</td>
          <td>{{ review.shop.name }}</td>
          <td>{{ review.average_rating.toFixed(1) }}</td>
          <td>
            <div class="ui green button" @click="showShopReviewDetail(review)">内容を確認</div>
            <div :id="dialogId(review)" class="ui small modal">
              <i class="close icon"></i>
              <div class="header">{{ review.member.name || review.member.name_kana || '（未設定）' }} - {{ review.shop.name }}</div>
              <div class="scrolling content">
                <table v-if="review" class="ui definition keyValueTable table">
                  <tr>
                    <td>タイトル</td>
                    <td>{{ review.title }}</td>
                  </tr>
                  <tr>
                    <td>口コミ内容</td>
                    <td><div class="linebreak">{{ review.contents }}</div></td>
                  </tr>
                  <tr>
                    <td>総合評価</td>
                    <td>{{ review.average_rating.toFixed(1) }}</td>
                  </tr>
                  <tr>
                    <td>アクセス</td>
                    <td>{{ review.access_rating.toFixed(1) }}</td>
                  </tr>
                  <tr>
                    <td>サービス</td>
                    <td>{{ review.service_rating.toFixed(1) }}</td>
                  </tr>
                  <tr>
                    <td>会場</td>
                    <td>{{ review.room_rating.toFixed(1) }}</td>
                  </tr>
                  <tr>
                    <td>料理・ドリンク</td>
                    <td>{{ review.food_drink_rating.toFixed(1) }}</td>
                  </tr>
                  <tr>
                    <td>設備</td>
                    <td>{{ review.facility_rating.toFixed(1) }}</td>
                  </tr>
                  <tr>
                    <td>コスパ</td>
                    <td>{{ review.cost_performance_rating.toFixed(1) }}</td>
                  </tr>
                  <tr>
                    <td>利用分類</td>
                    <td>{{ review.is_company ? '法人利用' : '個人利用' }}</td>
                  </tr>
                  <tr>
                    <td>会場種別</td>
                    <td>{{ review.usage_type_label }}</td>
                  </tr>
                  <tr>
                    <td>利用カテゴリー</td>
                    <td>{{ review.category_label }}</td>
                  </tr>
                  <tr>
                    <td>利用人数</td>
                    <td>{{ review.people }}人</td>
                  </tr>
                  <tr>
                    <td>利用金額</td>
                    <td>{{ review.total_price | formatCurrency }}</td>
                  </tr>
                  <tr>
                    <td>性別</td>
                    <td>{{ review.gender_label }}</td>
                  </tr>
                  <tr>
                    <td>年齢</td>
                    <td>{{ review.age }}代</td>
                  </tr>
                </table>
              </div>
              <div class="actions">
                <div class="ui green button" :class="{'loading disabled': reviewForm.waiting}" @click="approve(review.id)">承認する</div>
                <div class="ui yellow button" :class="{'loading disabled': reviewForm.waiting}" @click="reject(review.id)">却下する</div>
                <div class="ui red button" :class="{'loading disabled': reviewForm.waiting}" @click="remove(review.id)">削除する</div>
                <button class="ui cancel button">閉じる</button>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            searchForm: this.createForm(this.query()),
            reviewForm: this.createForm(),
            pager: this.createPager(30, this.query().offset),
            reviews: [],
        };
    },
    created() {
        this.search(this.pager.current());
    },
    methods: {
        search(opt_position) {
            let position = opt_position || this.pager.first();
            this.merge(this.searchForm.model, position);
            this.replaceStateQuery(this.searchForm.model, ['limit']);
            return this.searchForm.get('/afadmin/api/reviews', function(response) {
                this.reviews = response.data;
                this.pager.update(response.data, response);
            }.bind(this));
        },
        showShopReviewDetail(review) {
            $('#review-dialog-' + review.id).modal('show');
        },
        dialogId(review) {
            return 'review-dialog-' + review.id;
        },
        approve(reviewId) {
            if (!confirm('本当に承認しますか？')) {
                return;
            }

            this.reviewForm.model.status = 'approved';
            this.reviewForm.put(`/afadmin/api/reviews/${reviewId}`, function() {
                $('.ui.modal').modal('hide');
                this.search();
            }.bind(this));
        },
        reject(reviewId) {
            if (!confirm('本当に却下しますか？')) {
                return;
            }

            this.reviewForm.model.status = 'rejected';
            this.reviewForm.put(`/afadmin/api/reviews/${reviewId}`, function() {
                $('.ui.modal').modal('hide');
                this.search();
            }.bind(this));
        },
        remove(reviewId) {
            if (!confirm('本当に削除しますか？')) {
                return;
            }

            this.reviewForm.delete(`/afadmin/api/reviews/${reviewId}`, function() {
                $('.ui.modal').modal('hide');
                this.search();
            }.bind(this));
        },
    }
};
</script>
